import React from "react";
import "./LinkItem.scss";

import Button from "components/Button";

const LinkItem = ({ url, type, title, handleDelete, index, canDelete }) => {
  const icons = {
    behance: "md-color-palette",
    codepen: "logo-codepen",
    dribbble: "logo-dribbble",
    facebook: "logo-facebook",
    instagram: "logo-instagram",
    linkedin: "logo-linkedin",
    stackoverflow: "md-code",
    twitch: "logo-twitch",
    twitter: "logo-twitter",
    website: "md-globe",
    custom: "md-globe"
  };

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="LinkItem"
    >
      <i className={`ion ion-${icons[type.value]}`} />
      {type.value === "custom" ? title : type.label}
      {canDelete ? (
        <Button onClick={handleDelete} index={index} type="primary">
          Delete
        </Button>
      ) : null}
    </a>
  );
};

export default LinkItem;

// <div key={i}>
//   <a
//     href={link.url}
//     target="_blank"
//     rel="noopener noreferrer"
//   >
//     {link.type.value === "custom"
//       ? link.title
//       : link.type.label}
//   </a>
// </div>
